import { createDateRangeFromType } from 'owa-datetime-utils';
import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';
import goToToday from '../actions/goToToday';
import { orchestrator } from 'satcheljs';
import { today } from 'owa-datetime';
import { updateDataFetchRange } from 'owa-publishedcalendar-settings';
import { updateDateRange, updateSelectedDate } from 'owa-calendar-surface';

/**
 * Orchestrator to set today as the selected date
 */
orchestrator(goToToday, () => {
    const surfaceStore = getSurfaceStore();
    const currentDay = today();

    const newDateRange = createDateRangeFromType(
        surfaceStore.dateRangeType,
        currentDay,
        surfaceStore.userOptions.weekStartDay,
        surfaceStore.userOptions.workDays,
        1 // TODO VSO 80763: Implement flexible day view store prop in published calendar surface store
    );

    updateDataFetchRange(newDateRange, surfaceStore.userOptions.weekStartDay);
    updateDateRange(newDateRange, surfaceStore);
    updateSelectedDate(currentDay, surfaceStore);
});
